export default __webpack_public_path__ + "static/media/dinoRiders.c32df717.png";